import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import I_LOGS from '../interfaces/I_LOGS';
import {
  getLogsChargeResponse,
  getLogsActivityResponse,
  getLogsCollaboratorResponse,
  getLogsCustomerResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- LOGS
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  id: number;
  from_date?: string;
  to_date?: string;
  action?: string[];
  user?: number;
}
/**
 * Récupère l'historique de la charge'
 * @param obj
 * @returns
 */
const getLogsCharge = async ({
  accessToken,refreshToken,dispatch,state,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<I_LOGS> => {
  logger.debug('ApiServices - getLogsCharge - ');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getLogsChargeResponse({
        accessToken:usedAccessToken,
        id,
        page,
        from_date,to_date,action,user,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getLogsCharge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_LOGS = await response.json();
  logger.debug('ApiServices - getLogsCharge - ok, returned body',body);
  return body;
};
/**
 * Récupère l'historique de la charge'
 * @param obj
 * @returns
 */
const getLogsActivity = async ({
  accessToken,refreshToken,dispatch,state,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<I_LOGS> => {
  logger.debug('ApiServices - getLogsActivity - ');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getLogsActivityResponse({
        accessToken:usedAccessToken,
        id,
        page,
        from_date,to_date,action,user,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getLogsActivity - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_LOGS = await response.json();
  logger.debug('ApiServices - getLogsActivity - ok, returned body',body);
  return body;
};

/**
 * Récupère l'historique du collab
 * @param obj
 * @returns
 */
const getLogsCollaborator = async ({
  accessToken,refreshToken,dispatch,state,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<I_LOGS> => {
  logger.debug('ApiServices - getLogsCollaborator - ');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getLogsCollaboratorResponse({
        accessToken:usedAccessToken,
        id,
        page,
        from_date,to_date,action,user,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getLogsCollaborator - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_LOGS = await response.json();
  logger.debug('ApiServices - getLogsCollaborator - ok, returned body',body);
  return body;
};

/**
 * Récupère l'historique du customer
 * @param obj
 * @returns
 */
const getLogsCustomer = async ({
  accessToken,refreshToken,dispatch,state,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<I_LOGS> => {
  logger.debug('ApiServices - getLogsCustomer - ');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getLogsCustomerResponse({
        accessToken:usedAccessToken,
        id,
        page,
        from_date,to_date,action,user,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getLogsCustomer - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_LOGS = await response.json();
  logger.debug('ApiServices - getLogsCustomer - ok, returned body',body);
  return body;
};

const logsServices = {
  getLogsCharge,
  getLogsActivity,
  getLogsCollaborator,
  getLogsCustomer,
};

export default logsServices;
